module.exports = window["wc"]["wcBlocksSharedHocs"];